module.exports = __webpack_public_path__ + "img/start-3.15a15f5.png";